import React, { useEffect, useState } from "react";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";
import { Select } from "antd";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";

const UserFilter = ({ onOpen, onClose, setFilterData, initialFilter }) => {
  const [status, setStatus] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    if (onOpen) {
      setStatus(initialFilter?.status || "");
      setRole(initialFilter?.role || "");
    }
  }, [onOpen, initialFilter]);

  const handleSave = () => {
    setFilterData({ status, role });
    onClose();
  };

  const handleCancel = () => {
    setFilterData({ status: "", role: "" });
    setStatus("");
    setRole("");
    onClose();
  };

  return (
    <div>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div>
          <h3 className="text-xl">Filter</h3>
        </div>
        <div
          style={{
            border: "1px solid #ebedf3",
            borderRadius: "10px",
            padding: "10px",
          }}
        >
          <div className="mx-10">
            <Select
              value={status || undefined}
              onChange={(val) => setStatus(val)}
              placeholder="Status"
              className="text-lg font-light h-14 w-full my-10"
              allowClear
              options={[
                { label: "Active", value: "Active" },
                { label: "Inactive", value: "Inactive" },
              ]}
            />
          </div>
          <div className="mx-10">
            <Select
              value={role || undefined}
              onChange={(val) => setRole(val)}
              placeholder="Role"
              className="text-lg font-light h-14 w-full my-2"
              allowClear
              options={[
                { value: "employee", label: "Employee" },
                { value: "vendor", label: "Vendor" },
                { value: "user", label: "User" },
              ]}
            />
          </div>
          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Reset"
              onClick={handleCancel}
              className="text-base font-normal h-[50px] w-[160px]"
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Save"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
            />
          </div>
        </div>
      </DailogBox>
    </div>
  );
};

export default UserFilter;
